var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.708 6.491L12.502 6.491L17.49 1.491L15.999 0L11.001 4.991L11.001 5.783L10.725 6.057C9.588 5.083 8.115 4.491 6.5 4.491C2.91 4.491 0 7.401 0 10.991C0 14.581 2.91 17.491 6.5 17.491C10.09 17.491 13 14.581 13 10.991C13 9.376 12.407 7.902 11.432 6.765L11.708 6.491ZM2 10.991C2 8.505 4.014 6.491 6.5 6.491C8.985 6.491 11 8.505 11 10.991C11 13.476 8.985 15.491 6.5 15.491C4.014 15.491 2 13.476 2 10.991Z",
    transform: "matrix(1 0 0 -1 3 20.491)",
    id: "path_1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    id: "artboard_1"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#artboard_1",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mask_1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Search-/-Filled",
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.708 6.491L12.502 6.491L17.49 1.491L15.999 0L11.001 4.991L11.001 5.783L10.725 6.057C9.588 5.083 8.115 4.491 6.5 4.491C2.91 4.491 0 7.401 0 10.991C0 14.581 2.91 17.491 6.5 17.491C10.09 17.491 13 14.581 13 10.991C13 9.376 12.407 7.902 11.432 6.765L11.708 6.491ZM2 10.991C2 8.505 4.014 6.491 6.5 6.491C8.985 6.491 11 8.505 11 10.991C11 13.476 8.985 15.491 6.5 15.491C4.014 15.491 2 13.476 2 10.991Z",
    transform: "matrix(1 0 0 -1 3 20.491)",
    id: "Mask",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mask_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u21B3-Icon-Color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L24 0L24 24L0 24L0 0Z",
    id: "Rectangle",
    fill: "#000000",
    fillOpacity: 0.5411765,
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fc414972dc723ac57f7022ac395c4bdb.svg";
export { ForwardRef as ReactComponent };